module.exports = __webpack_public_path__ + "static/media/blog-new2.eb717ac6.jpg";